module.exports = __webpack_public_path__ + "static/media/icon-savings-light.c2cb4fa2.svg";